export default __webpack_public_path__ + "static/media/Gauntlets of the Black Pharaoh.e0c377ff.jpg";